module.exports = __webpack_public_path__ + "img/i_x_n_g.86005024.svg";